import Settings from "./Settings";
import { AuthToken } from "./AuthToken";

import ProcessingResult from "../framework/ProcessingResult";

import WorkspaceDto from "../classes/dtos/workspacemodule/WorkspaceDto";

const WorkspaceApi = {

    GetWorkspacesAsync: async function (): Promise<ProcessingResult<WorkspaceDto[]>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/Workspace/GetWorkspaces", {
            method: "GET",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(data.workspaces.map((e: { id: number; name: string }) => new WorkspaceDto(e.id, e.name)));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    CreateWorkspaceAsync: async function (name: string): Promise<ProcessingResult<number>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/Workspace/CreateWorkspace", {
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            },
            body: JSON.stringify({
                'name': name
            })
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(data.id);
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    UpdateWorkspaceAsync: async function (id: number, name: string): Promise<ProcessingResult<boolean>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/Workspace/UpdateWorkspace", {
            method: "PUT",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            },
            body: JSON.stringify({
                'id': id,
                'name': name
            })
        });

        if (response.status === 200) {
            return ProcessingResult.Ok(true);
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    DeleteWorkspaceAsync: async function (id: number): Promise<ProcessingResult<boolean>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/Workspace/DeleteWorkspace?id=" + id, {
            method: "DELETE",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            return ProcessingResult.Ok(true);
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },
};

export default WorkspaceApi;
